"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new /** @class */ (function () {
    function Common() {
    }
    /**
     * Captitalize the first letter
     * @param text
     * @returns Capitalixed text
     */
    Common.prototype.capitalizeFirstLetter = function (text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    /**
     * Get Device width
     * @returns device width
     */
    Common.prototype.getDeviceWidth = function () {
        return (window.innerWidth > 0) ? window.innerWidth : screen.width;
    };
    /**
     *
     * @param a
     * @param b
     * @returns difference
     */
    Common.prototype.diff = function (a, b) {
        return Math.abs(a - b);
    };
    /**
     * Get scrolling element
     * @param document
     * @returns Scrolling element
     */
    Common.prototype.getScrollingElement = function (document) {
        var bodyHeight = Math.max(document.body.clientHeight, document.body.offsetHeight);
        var htmlHeight = Math.max(document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
        return bodyHeight > htmlHeight ?
            document :
            document.body;
    };
    /**
     * Set cookie
     * @param cookieName
     * @param cookieValue
     * @param expireDays
     */
    Common.prototype.setCookie = function (cookieName, cookieValue, expireDays) {
        var d = new Date();
        d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";secure=true;path=/";
    };
    /**
     * Get cookie value by name
     * @param cookieName
     * @returns Cookie value
     */
    Common.prototype.getCookie = function (cookieName) {
        var name = cookieName + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    return Common;
}());
